import Register from '@Services/Register';
import RegisterData from '@Services/RegisterData';

import { bulkIdSubmit } from '@Pages/Login/BulkIdRegisterModal/actions';
import {
  bulkIdRegisterSetIpAddressReducerType,
  bulkIdRegisterSetLoginFailReducerType,
  bulkIdRegisterSetIsLoadingReducerType,
  bulkIdRegisterSetDataReducerType,
} from './BulkIdRegisterConstants';
import { data as dataSelector } from './BulkIdRegisterSelectors';

export function setIpAddress(ipAddress) {
  return {
    type: bulkIdRegisterSetIpAddressReducerType,
    payload: { ipAddress },
  };
}

export function setLoginFail(loginFail) {
  return {
    type: bulkIdRegisterSetLoginFailReducerType,
    payload: { loginFail },
  };
}

export function setIsLoading(isLoading) {
  return {
    type: bulkIdRegisterSetIsLoadingReducerType,
    payload: { isLoading },
  };
}

export function setData(data) {
  return {
    type: bulkIdRegisterSetDataReducerType,
    payload: data,
  };
}

export const init = () => {
  return async (dispatch) => {
    await RegisterData.getIpAddress()
      .then((ip) => {
        dispatch(setIpAddress(ip));
      })
      .catch(Logger.error);
    Register.clear();
  };
};

export const submit = () => {
  return async (dispatch, getState) => {
    const data = dataSelector(getState());
    dispatch(setIsLoading(true));

    try {
      await dispatch(bulkIdSubmit(data));
      dispatch(setLoginFail(null));
    } catch (error) {
      dispatch(setData({ bulkId: '', bulkPassword: '' }));
      dispatch(setLoginFail({ bulkIdInvalid: true }));
    }

    dispatch(setIsLoading(false));
  };
};
